import BaseView from './BaseView';

import barba from '@barba/core';
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
//import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
gsap.registerPlugin(SplitText);

import throttle from 'lodash.throttle';
import { lightOrDark } from '../../utils';

let view = null;

class ShopStory extends BaseView {
	constructor(container) {
		super(container);

        this.layoutElm = this.container.querySelector('[data-layout-elm]');

        this.collectionName = this.container.querySelector('[data-collection-name]');
        this.collectionDescriptionName = this.container.querySelector('[data-collection-description-name]');
		this.collectionDescriptionText = this.container.querySelector('[data-collection-description-text]');
        this.organismName = this.container.querySelector('[data-organism-name]');

		this.products = this.container.querySelectorAll('[data-product-card]');

        this.isInitialised = false;

		// Scroll Listener
		this.boundScrollListener = throttle(this.handleScroll.bind(this), 0);
		window.addEventListener('scroll', this.boundScrollListener);
		this.handleScroll();
	}

	handleScroll() {
		if(!this.activeProduct) {
			return;
		}
		this.activeProduct.classList.remove('is-active');
		this.activeProduct = null;
		if(this.activeSection) {
			this.updateActiveSection(this.activeSection);
		}
	}

	init() {
        this.isInitialised = true;

        this.splitOrganismName = new SplitText(this.organismName, {
            type: "words,chars",
            charsClass: "char"
        });

		this.layoutElm.classList.add('is-ready');

		gsap.to(this.splitOrganismName.chars, {
			opacity: 1,
			duration: 0,
			stagger: 0.05,
			delay: 0.8
		});

	}

	afterEnterFunctions() {
		// Observe Sections
		this.sectionObserver = new IntersectionObserver(this.handleSectionIntersection.bind(this), {
            rootMargin: '-49% 0% -49% 0%',
            treshold: 0
        });

        this.storySections = this.container.querySelectorAll('[data-story-section]');
        if(this.storySections) {
            this.storySections.forEach(section => {
				this.sectionObserver.observe(section);
			});
        }
	}

    handleSectionIntersection(entries) {
        entries.forEach(entry => {
			const ratio = entry.intersectionRatio;
			const target = entry.target;
			if (ratio > 0) { // Section is in center of viewport
				this.updateActiveSection(target);
			}
		});
    }

    updateActiveSection(section) {
        if(this.activeSection) {
            this.activeSection.classList.remove('is-active');
        }
        this.activeSection = section;
        this.activeSection.classList.add('is-active');

		const color = section.dataset.color;
		const brightness = lightOrDark(color);
		let bgColor = 'black';
		if(brightness=='dark') {
			bgColor = 'white';
		}

		barba.colorManager.setTo(color, bgColor, 0.8);

		//const scrambleElms = [];

        const collection = section.dataset.collection;
		this.collectionName.innerHTML = collection;
		//scrambleElms.push(this.collectionName);
		this.collectionDescriptionName.innerHTML = collection+' Collection';
		//scrambleElms.push(this.collectionDescriptionName);
		const collectionDescriptionText = section.dataset.collectionDescription;
		this.collectionDescriptionText.innerHTML = collectionDescriptionText;

		// const descElms = this.collectionDescriptionText.querySelectorAll('a');
		// descElms.forEach(elm => {
		// 	scrambleElms.push(elm);
		// });

        const organism = section.dataset.organism;
        this.organismName.innerHTML = organism;
		//scrambleElms.push(this.organismName);

        if(!this.isInitialised) {
            this.init();
        }

        const code = section.dataset.code;
        barba.logoLayerDirector.newCode(code);


		// Product Links
		this.productLinks = this.container.querySelectorAll('.product-link');
		this.productLinks.forEach(link => {
			link.addEventListener('mouseover', () => {
				const productCode = link.dataset.code;
         		barba.logoLayerDirector.newCode(productCode);
				barba.colorManager.makeLogoGreen();
			});

			link.addEventListener('mouseleave', () => {
				barba.colorManager.setTo(color, bgColor, 0.8);
        		barba.logoLayerDirector.newCode(code);
			})
		});

		// scrambleElms.forEach(elm => {
		// 	gsap.to(elm, {
		// 		duration: 1,
		// 		scrambleText: {
		// 			text: '{original}',
		// 			chars: elm.innerText,
		// 			revealDelay: 0.5,
		// 			speed: 0.3,
		// 		}
		// 	});
		// });

    }

	destroy() {
		this.sectionObserver.disconnect();
		window.removeEventListener('scroll', this.boundScrollListener);
	}
}

export default {
	namespace: 'template-shop-story',
	beforeEnter: ({ current, next, trigger }) => {
		view = new ShopStory(next.container);
	},
	afterEnter: ({ current, next, trigger }) => {
		view.afterEnterFunctions();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
